module.exports = __webpack_public_path__ + "img/background.4d009263.png";